import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RegionComponent from "../components/RegionComponent";
import AlertComponent from "../../../components/AlertComponent";
import getRegionsAPI from "../api/getRegionsAPI";

const Regions = () => {
  const [regionDeletable, setRegionDeletable] = useState(false);
  const [regions, setRegions] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertData, setAlertData] = useState({
    title: "",
    content: "",
  });

  // use Effect to Get Region Data
  useEffect(() => {
    const getRegionData = async () => {
      setRegions(await getRegionsAPI());
    };
    getRegionData();
  }, [regionDeletable]);

  return (
    <>
      <section className="body-font text-gray-600">
        <div className="container mx-auto py-8">
          <div className="mb-12 flex flex-col md:flex-row-reverse justify-between items-center md:border-b pb-2">
            <h2 className="text-right text-2xl font-bold p-4 mb-4 md:mb-0">المناطق</h2>
            <Link
              className="text-lg text-blue-500 font-bold underline"
              to={`${process.env.PUBLIC_URL}/add-region`}
            >
              إضافة منطقة جديدة
            </Link>
          </div>
          <div className="-m-4 flex flex-wrap flex-row-reverse">
            <div className="container mx-auto p-4">
              {alert ? <AlertComponent title={alertData.title} content={alertData.content} /> : ""}
              <div className="overflow-x-auto">
                <table className="min-w-full overflow-hidden rounded-lg bg-white">
                  <thead className="bg-gray-100">
                    <tr className="text-sm uppercase leading-normal text-gray-600">
                      <th className="px-4 py-3 text-right"> </th>
                      <th className="px-4 py-3 text-right"> الحد الأدنى من الطلبيات</th>
                      <th className="px-4 py-3 text-right">المنطقة </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm font-light text-gray-600">
                    {regions.map((region) => {
                      return (
                        <RegionComponent
                          key={region.id}
                          region={region}
                          setAlert={setAlert}
                          setAlertData={setAlertData}
                          setRegionDeletable={setRegionDeletable}
                        />
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Regions;
